"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import WaveHeader, { WaveHeaderPinnedSide } from "@/components/waves/header/WaveHeader";
import { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
import BrainRightSidebarContent from "../right-sidebar/BrainRightSidebarContent";
import BrainRightSidebarFollowers from "../right-sidebar/BrainRightSidebarFollowers";
import { useLayout } from "../my-stream/layout/LayoutContext";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface BrainMobileAboutProps {
  readonly activeWaveId: string | null;
}
enum Mode {
  CONTENT = "CONTENT",
  FOLLOWERS = "FOLLOWERS",
}
const BrainMobileAbout: React.FC<BrainMobileAboutProps> = t0 => {
  const $ = _c(16);
  const {
    activeWaveId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== activeWaveId) {
    t1 = [QueryKey.WAVE, {
      wave_id: activeWaveId
    }];
    t2 = async () => await commonApiFetch({
      endpoint: `waves/${activeWaveId}`
    });
    $[0] = activeWaveId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = !!activeWaveId;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: 60000,
      placeholderData: keepPreviousData
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: wave
  } = useQuery(t4);
  const [mode, setMode] = useState(Mode.CONTENT);
  const {
    mobileAboutViewStyle
  } = useLayout();
  let t5;
  if ($[7] !== mode) {
    t5 = () => {
      if (mode === Mode.FOLLOWERS) {
        setMode(Mode.CONTENT);
      } else {
        setMode(Mode.FOLLOWERS);
      }
    };
    $[7] = mode;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onFollowersClick = t5;
  let t6;
  if ($[9] !== mode || $[10] !== onFollowersClick || $[11] !== wave) {
    t6 = wave && <><WaveHeader wave={wave} onFollowersClick={onFollowersClick} useRing={false} useRounded={false} pinnedSide={WaveHeaderPinnedSide.LEFT} />{mode === Mode.CONTENT && <BrainRightSidebarContent wave={wave} />}{mode === Mode.FOLLOWERS && <BrainRightSidebarFollowers wave={wave} closeFollowers={() => setMode(Mode.CONTENT)} />}</>;
    $[9] = mode;
    $[10] = onFollowersClick;
    $[11] = wave;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== mobileAboutViewStyle || $[14] !== t6) {
    t7 = <div className="tw-px-2 sm:tw-px-4 md:tw-px-6 tw-overflow-y-auto no-scrollbar tw-divide-y tw-divide-solid tw-divide-iron-800 tw-divide-x-0" style={mobileAboutViewStyle}>{t6}</div>;
    $[13] = mobileAboutViewStyle;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default BrainMobileAbout;